<template>
  <div class="text-control-container">
    <div class="left">
      <div class="left-content" v-if="data">
        <style-setting :data="data" :collapses="data.styleList" @recoverSetting="recoverSetting"></style-setting>
      </div>
      <div class="operation">
        <el-button type="primary" @click="save">保存</el-button>
        <el-button plain @click="$emit('closeDialog')">关闭</el-button>
      </div>
    </div>
    <div class="right" :style="getBgc(data.backgroundAndBorder)">
      <el-input type="textarea" :resize="'none'" v-model="data.textContent" :style="getFontStyle(data.textFont)"></el-input>
    </div>
  </div>
</template>

<script>
import styleSetting from './style-setting/style-setting'
import setStyle from '../../../public/setStyle'
export default {
  name: 'text-control',
  props: {
    data: {
      type: Object,
      required: true
    },
    getStyleSetting: {
      type: Function,
      required: true
    }
  },
  components: {styleSetting},
  mixins: [setStyle],
  methods: {
    save () {
      this.$emit('addControls', this.data, true)
    },
    // 恢复默认设置
    recoverSetting () {
      let defaultStyle = this.getStyleSetting(this.data.type)
      defaultStyle && this.$_.assign(this.data, defaultStyle)
    }
  }
}
</script>

<style lang="scss">
  .text-control-container {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    & > .left {
      width: 230px;
      height: 100%;
      border-right: 1px solid #DCDCDC;
      .left-content {
        height: calc(100% - 60px);
        padding: 9px 13px 9px 8px;
      }
      .operation {
        text-align: center;
        padding-top: 16px;
        .el-button {
          width: 78px;
          height: 26px;
          border-radius: 3px;
          padding: 0;
        }
        .el-button + .el-button {
          margin-left: 22px;
        }
      }
    }
    & > .right {
      width: calc(100% - 230px);
      height: 100%;
      padding: 10px 28px 16px 16px;
      .el-textarea {
        height: 100%;
        border-radius: 0;
        .el-textarea__inner {
          height: 100%;
          border-radius: 0;
          color: inherit;
          font-size: inherit;
          font-family: inherit;
          font-style: inherit;
          font-weight: inherit;
          text-decoration: inherit;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/report/design/customPage/text-control.vue